import { SmartTable } from '../../../../../components/smart-table/smart-table.model';

export class Controller {

    /** @ngInject */
    constructor() {
    }

    $onInit() {
        this.st = new SmartTable();
        this.allItems = [...this.hardTokenUsers, ...this.hardTokens]
            .filter(({companyUserId}) => !companyUserId);
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/hard-token-users/hard-token-users.controller.js